import React from 'react';
import { Award, Users, Clock, CheckCircle } from 'lucide-react';

const About = () => {
  const features = [
    {
      icon: <Award className="w-8 h-8" />,
      title: 'Mais de 20 Anos',
      description: 'Tradição e experiência no mercado de vidros desde 2004',
    },
    {
      icon: <Users className="w-8 h-8" />,
      title: 'Equipe Especializada',
      description: 'Profissionais qualificados para projetos de alta complexidade',
    },
    {
      icon: <Clock className="w-8 h-8" />,
      title: 'Atendimento Ágil',
      description: 'Resposta rápida via WhatsApp e visita técnica sem compromisso',
    },
    {
      icon: <CheckCircle className="w-8 h-8" />,
      title: 'Acabamento Premium',
      description: 'Compromisso com qualidade em cada detalhe do projeto',
    },
  ];

  return (
    <section id="about" className="section-padding bg-[var(--bg-primary)]">
      <div className="container-custom">
        <div className="grid grid-cols-1 lg:grid-cols-2 gap-16 items-center">
          {/* Left Content */}
          <div>
            <h2 className="heading-1 mb-6">
              Qualidade e sofisticação em cada projeto
            </h2>
            <p className="body-large text-[var(--text-secondary)] mb-8 leading-relaxed">
              A <strong className="text-[var(--text-primary)]">Forti Vidros</strong> é referência
              em Sorocaba quando o assunto é envidraçamento de sacadas, boxes de banheiro e
              soluções personalizadas em vidro.
            </p>
            <p className="body-regular text-[var(--text-secondary)] mb-8 leading-relaxed">
              Com <strong className="text-[var(--text-primary)]">mais de 20 anos de experiência</strong>,
              entregamos projetos que combinam funcionalidade, segurança e design sofisticado.
              Trabalhamos com materiais de primeira linha e acabamento premium, garantindo a
              satisfação total dos nossos clientes.
            </p>
            <p className="body-regular text-[var(--text-secondary)] mb-8 leading-relaxed">
              Do atendimento inicial à instalação final, nosso compromisso é com a excelência.
              Cada detalhe é pensado para transformar sua sacada ou banheiro em um ambiente
              elegante e protegido.
            </p>

            {/* CTA */}
            <a
              href="https://wa.me/5515991253527?text=Olá!%20Gostaria%20de%20conhecer%20mais%20sobre%20os%20serviços."
              target="_blank"
              rel="noopener noreferrer"
              className="btn-primary"
            >
              Conheça nossos serviços
            </a>
          </div>

          {/* Right Features Grid */}
          <div className="grid grid-cols-1 sm:grid-cols-2 gap-6">
            {features.map((feature, index) => (
              <div
                key={index}
                className="bg-[var(--bg-secondary)] p-6 hover-lift fade-in"
                style={{ animationDelay: `${index * 0.1}s` }}
              >
                <div className="text-[var(--accent-gold)] mb-4">
                  {feature.icon}
                </div>
                <h3 className="heading-3 mb-2">{feature.title}</h3>
                <p className="body-small text-[var(--text-secondary)]">
                  {feature.description}
                </p>
              </div>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
};

export default About;
